import styled from 'styled-components';

export const Wrapper = styled.div`
  background: #f5f6f7;
  padding: 40px;
  flex: 1;
`;

export const PreTitle = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
  margin-bottom: 24px;
`;

export const Title = styled.div`
font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
`;

export const Text = styled.div`
  margin-top: 12px;
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);

  b {
    color: #EC5E59;
  }

  strong {
    font-weight: 700;
    color: rgba(0, 27, 59, 1);
  }

  a:active, a:visited, a:link {
    color: #97b8f6;
    text-decoration: underline;
  }

  a:hover {
    text-decoration: none;
  }

  ul {
    list-style-type: disc;
    margin-left: 20px;
    margin-top: 10px;
  }

  ul li {
    font-size: 16px !important;
  }

  p {
    margin-bottom: 8px;
  }

  p:last-child {
    margin-bottom: 0;
  }

  span {
    font-weight: 700;
  }
`;

export const Alert = styled.div`
  margin-top: 24px;
  background: #fbedd5;
  border: 1px solid #f9c151;
  border-radius: 4px;
  padding: 22px 20px;
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;

  span {
    display: flex;
    flex: 0 0 28px;
    width: 28px;
    height: 28px;
    background: #2196f3;
    border-radius: 28px;
    color: #fbedd5;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
`;

export const SubTitle = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;

export const Table = styled.div`
  width: 100%;
  border-radius: 8px;
  border: 1px solid #d5d9dd;
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: #ffffff;
  margin-top: 12px;
  overflow: hidden;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  width: auto;

  ${p => p.background && `
    background: ${p.background};
  `}
`;

export const Cell = styled.div`
  flex: 1;
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  padding: 9px 16px;
  display: flex;
  align-items: center;

  ${p => p.color && `
    color: ${p.color};
  `}

  ${p => p.fontWeight && `
    font-weight: ${p.fontWeight};
  `}

  ${p => p.background && `
    background: ${p.background};
  `}
`;

export const ChartWrapper = styled.div`
  padding: 20px;
`;

export const ChartTitle = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.94);
  margin-bottom: 20px;
  ${p => p.isFlex && `
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  `}
  img {
    display: inline-block;
    width: 14px !important;
    height: 14px;
    position: relative;
    top: -1px;
    margin-left: 5px;
  }
`;

export const ChartData = styled.div`
  max-width: 65%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
`;

export const FormulaName = styled.div`
  padding: 16px;
  text-align: center;
  border-radius: 8px;
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: #ffffff;

  ${p => p.background && `
    background-color: ${p.background};
  `}

  ${p => p.padding && `
    padding: ${p.padding};
  `}

  ${p => p.color && `
    color: ${p.color};
  `}
`;

export const FormulaValue = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  text-align: center;

  ${p => p.fontSize && `
    font-size: ${p.fontSize};
  `}

  ${p => p.isNegative && `
    color: #EC5E59;
  `}

  span.divider {
    display: block;
    width: 100%;
    height: 1px;
    background: rgba(0, 27, 59, 0.94);
    margin: 13px 0 13px -5px;
    width: calc(100% + 10px);
  }

  b, .negative-value {
    color: #EC5E59;
  }
`;



// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/components/ui.js